
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
// const sysInfo = {
//   apiRemote: 'http://47.111.75.34:8080/app/mock/22'
// }
export function insertProduct (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/product',
    method: 'POST',
    data: parameter
  })
}
export function updateProduct (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/product',
    method: 'POST',
    data: parameter
  })
}
export function deleteProduct (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/product',
    method: 'DELETE',
    params: parameter
  })
}
export function getProductList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/product/list',
    method: 'GET',
    params: parameter
  })
}
export function getProductInfo (parameter) {
return axios({
    url: sysInfo.apiRemote + '/product/detail',
    method: 'GET',
    params: parameter
  })
}
export function getProductSale (parameter) {
  return axios({
      url: sysInfo.apiRemote + '/contract/sale/product',
      method: 'GET',
      params: parameter
    })
  }